export enum EsIndex {
  UserAndEventData = 'UserAndEventData',
  CatalogData = 'CatalogData',
}

export enum ESIndex {
  Catalog = 'Catalog',
  UserAndEvent = 'UserAndEvent',
}

export type CatalogESIndexConfig = Partial<{
  esIndex: ESIndex;
  catalogName: string;
}>;

type UserAndEventESIndexConfig = {
  esIndex?: ESIndex;
};

export type ESIndexConfig = CatalogESIndexConfig | UserAndEventESIndexConfig;
